// extracted by mini-css-extract-plugin
export default {"card":"card_card__nUOu4","title":"card_title__cTxcM"};